<template>
  <div class="page">
    <header>
      <button @click="$router.back()">‹</button>
      <h1>{{ $t('setting.paypwdtitle') }}</h1>
      <span></span>
    </header>
    <main>
      <section>
        <div class="shield">
          <van-image round width="3.35rem" height="3.35rem" :src="smallLogo">
            <template #loading><van-loading type="spinner" color="#e6c474" /></template>
            <template #error><img class="fallback-logo" src="/img/the-weks-selective.svg?v=2" alt="THE WEKS SELECTIVE"></template>
          </van-image>
        </div>
        <p class="hint">{{ hasPayPassword ? $t('setting.change') : $t('setting.fundPassword') }}</p>

        <label v-if="hasPayPassword">{{ $t('setting.oldpwd') }}</label>
        <van-field v-if="hasPayPassword" v-model.trim="oldPassword" type="password" inputmode="numeric"
          maxlength="6" :placeholder="$t('setting.oldpwd')" />

        <label>{{ $t('setting.newpwd') }}</label>
        <van-field v-model.trim="newPassword" type="password" inputmode="numeric"
          maxlength="6" :placeholder="$t('setting.newpwd')" />

        <label>{{ $t('setting.repaypwd') }}</label>
        <van-field v-model.trim="confirmPassword" type="password" inputmode="numeric"
          maxlength="6" :placeholder="$t('setting.repaypwd')" />

        <button class="submit" :disabled="submitting" @click="submit">
          {{ submitting ? $t('cryptoAddress.saving') : $t('setting.confirm') }}
        </button>
      </section>
    </main>
  </div>
</template>

<script>
export default {
  data() {
    return { oldPassword: '', newPassword: '', confirmPassword: '', hasPayPassword: false, submitting: false };
  },
  computed: {
    smallLogo() {
      const baseInfo = this.$store.getters.getBaseInfo || {};
      return baseInfo.ico || baseInfo.logo || '/img/the-weks-selective.svg?v=2';
    }
  },
  methods: {
    validPassword(value) { return /^\d{6}$/.test(String(value || '')); },
    loadUser() {
      this.$http({ method: 'get', url: 'user_info' }).then(res => {
        if (res.code === 200) this.hasPayPassword = Boolean(res.data && res.data.paypassword);
      });
    },
    submit() {
      if (this.hasPayPassword && !this.validPassword(this.oldPassword)) return this.$toast(this.$t('setting.plseall'));
      if (!this.validPassword(this.newPassword) || !this.validPassword(this.confirmPassword)) return this.$toast(this.$t('setting.plseall'));
      if (this.newPassword !== this.confirmPassword) return this.$toast(this.$t('setting.pswwrong'));
      this.submitting = true;
      this.$http({
        method: 'post',
        url: 'user_set_paypw',
        data: { paypassword: this.newPassword, old_paypassword: this.hasPayPassword ? this.oldPassword : '' }
      }).then(res => {
        this.submitting = false;
        if (res.code !== 200) return this.$toast(res.msg);
        this.$toast.success(res.msg);
        this.$router.replace('/Mine');
      }).catch(() => { this.submitting = false; });
    }
  },
  created() {
    if (!localStorage.getItem('token')) return this.$router.replace('/Login');
    this.loadUser();
  }
};
</script>

<style lang="less" scoped>
.page{min-height:100vh;color:#f2e7d4;background:linear-gradient(rgba(3,5,8,.88),rgba(3,5,8,.98)),url('../../assets/img/luxury-dating-bg-v2.png') center/cover fixed}
header{height:4.4rem;display:grid;grid-template-columns:4rem 1fr 4rem;align-items:center;border-bottom:1px solid rgba(218,180,105,.4);background:#05070a}header button{border:0;color:#efca72;background:transparent;font-size:2rem}h1{margin:0;text-align:center;color:#efd083;font-size:1.3rem}main{padding:1rem}section{padding:1.3rem;border:1px solid rgba(218,180,105,.42);border-radius:1.2rem;background:linear-gradient(145deg,#11141a,#07090d)}.shield{width:4.4rem;height:4.4rem;margin:0 auto;display:grid;place-items:center;border:1px solid #d5ac56;border-radius:50%;overflow:hidden;color:#efcf81;background:#17130d;box-shadow:0 0 20px rgba(220,177,88,.22)}.fallback-logo{width:3.35rem;height:3.35rem;border-radius:50%;object-fit:cover}.hint{text-align:center;color:#d5b66f;font-weight:700}label{display:block;margin:1rem 0 .5rem;color:#e6c477;font-weight:700}::v-deep .van-cell{padding:0 1rem;border:1px solid rgba(218,180,105,.38);border-radius:.8rem;background:#090c11}::v-deep .van-field__control{height:3.5rem;color:#f4ead9;font-size:1rem}::v-deep .van-field__control::placeholder{color:#756f68}.submit{width:100%;min-height:3.6rem;margin-top:1.5rem;border:1px solid #f0d184;border-radius:.9rem;color:#171006;background:linear-gradient(110deg,#ad7b32,#e8c876);font-size:1.05rem;font-weight:800}.submit:disabled{opacity:.65}

@media (max-width:430px){
  .page{width:100%;min-width:0;overflow-x:hidden;background-attachment:scroll}
  header{width:100%;height:auto;min-height:64px;padding-top:env(safe-area-inset-top);grid-template-columns:48px minmax(0,1fr) 48px}
  header button{width:48px;min-height:48px;font-size:28px}
  h1{min-width:0;padding:9px 3px;font-size:18px;line-height:1.25;overflow-wrap:anywhere}
  main{padding:14px 12px max(22px,env(safe-area-inset-bottom))}
  section{min-width:0;padding:18px 14px;border-radius:18px}
  .hint,label{line-height:1.35;overflow-wrap:anywhere}
  ::v-deep .van-cell{min-width:0;padding:0 13px}
  ::v-deep .van-field__value,::v-deep .van-field__body,::v-deep .van-field__control{min-width:0}
  ::v-deep .van-field__control{height:52px;font-size:16px}
  .submit{height:auto;min-height:52px;padding:10px;line-height:1.35;white-space:normal}
}
</style>
